module.exports = __webpack_public_path__ + "static_pest_wiki_details/img/step2.de45fed.svg";


//////////////////
// WEBPACK FOOTER
// ./static/images/step2.svg
// module id = g24a
// module chunks = 0